import React from 'react';
import ComponentLoader from '../components/component.loader';

const TaskPlatformUmd = () => (
  <div>
    <ComponentLoader componentPath="/taskPlatform/projectList" />
  </div>
);

export default TaskPlatformUmd;
